import { ChangeEvent, ReactNode, useCallback } from 'react'
import _ from 'lodash'
import { faBarcodeRead } from '@fortawesome/pro-solid-svg-icons'
import { L1ReasonableButton, L1SmallIconButton } from "../l1/L1Button"
import L1TextField from "../l1/L1TextField"
import { BarcodeType, RenderPlatform } from '@fusion-advantage/backcompat'
import { useBarcodeScannerPlugin } from '../../../lib/useNativePlugin'
import { ComplexElementSize } from '../ComplexElementSize'

type L3BarcodeScannerProps = {
	platform: RenderPlatform
	barcodeType: BarcodeType
	size: ComplexElementSize
	buttonOnly?: boolean
	buttonLabel?: string
	value?: string
	onChange: (value: string) => void
	onScan?: (value: string) => void
	disabled?: boolean
}

const L3BarcodeScanner = ({platform, barcodeType, size, buttonOnly, buttonLabel, value, onChange, onScan, disabled}: L3BarcodeScannerProps) => {
	const handleChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
		onChange(e.target.value)
	}, [onChange])

	const handleScanReceive = useCallback((code: string) => {
		if(onScan) {
			onScan(code)
		} else {
			onChange(code)
		}
	}, [onScan, onChange])

	const { showBarcodeScanner } = useBarcodeScannerPlugin({
		onReceive: handleScanReceive,
	})

	const handleScanClick = useCallback(() => {
		showBarcodeScanner({barcodeType})
	}, [showBarcodeScanner, barcodeType])

	if(buttonOnly) {
		return (
			<L1ReasonableButton
				label={buttonLabel ?? 'Scan Barcode'}
				icon={faBarcodeRead}
				onClick={handleScanClick}
				disabled={disabled}
			/>
		)
	}

	let tip: ReactNode = null
	if(platform === RenderPlatform.Native) {
		tip = <L1SmallIconButton icon={faBarcodeRead} onClick={handleScanClick} disabled={disabled}  />
	}
	return (
		<L1TextField
			size={size}
			suffixIcon={platform === RenderPlatform.Web ? faBarcodeRead : undefined}
			value={value}
			onChange={handleChange}
			disabled={disabled}
			tip={tip}
		/>
	)
}

export default L3BarcodeScanner